import type { TimingPerformances } from '../utils/timings/timings';

export type CuriosityParams = {
  isLocal: boolean;
  isDev: boolean;
  isQa: boolean;
  referrer_url: string;
  appEnableWidget: boolean;
  timingPerformances: TimingPerformances;
  debugEnabled: boolean;
};

export enum RouteType {
  ERRORPAGE = 'errorPage',

  HOTELDETAILS = 'hotelDetails',

  OSMAP = 'osmap',

  PRESEARCH = 'presearch',

  SEARCHRESULTS = 'searchresults',

  WAITING = 'waiting',

  WIDGET = 'widget',
}
